'use client';

import * as React from 'react';
import { useStore } from '@mui/x-internals/store';
import { chatSelectors } from "../selectors/index.js";
import { useChatStore } from "./useChatStore.js";
export function useChatStatus() {
  const store = useChatStore();
  const isStreaming = useStore(store, chatSelectors.isStreaming);
  const hasMoreHistory = useStore(store, chatSelectors.hasMoreHistory);
  const error = useStore(store, chatSelectors.error);
  const typingUserIds = useStore(store, chatSelectors.typingUserIdsForActiveConversation);
  return React.useMemo(() => ({
    isStreaming,
    hasMoreHistory,
    error,
    typingUserIds
  }), [error, hasMoreHistory, isStreaming, typingUserIds]);
}